import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';

@Component({
  selector: 'app-dml-visor-documento',
  templateUrl: './dml-visor-documento.component.html',
  styleUrls: ['./dml-visor-documento.component.scss']
})
export class DmlVisorDocumentoComponent implements OnInit {
  constructor(
    public  modalRefVisorDocumentoDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private detArchivoService:DetArchivoService,
  ){}

  //variables enviado desde el padre
  x_titulo:String;
  x_uid:String;

  tempBlob:Blob;
  pdfSource:string;
  urlSafe: SafeResourceUrl;

  ngOnInit(): void {

    console.log(this.x_uid);
    this.cargarDatoInicial();
  }

  cargarDatoInicial(){
    this.utilitarioService.loading = true;
    const cargarArchivo = this.detArchivoService.getFile(this.x_uid.toString()).toPromise()
    .then(data => {
      this.tempBlob = new Blob([data], { type: 'application/pdf' });

      this.pdfSource = window.URL.createObjectURL(this.tempBlob);
    });
    Promise.all([cargarArchivo])
    .then(response => {

      this.utilitarioService.loading = false;
    });
  }

  ngOnDestroy()
  {
    this.urlSafe = null;
    this.pdfSource = "";
  }
  onClosemodal(){
    this.modalRefVisorDocumentoDml.hide();

  }
  onDescargarArchivo(ext:string){
      saveAs(this.tempBlob,"plantilla"+ext);

  }
}
